import React, { useEffect, useRef, useState } from 'react'

import './index.scss'
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import EditIcon from "@mui/icons-material/Edit";
import EditNoteIcon from '@mui/icons-material/EditNote';

const TableFilters = (props: any) => {
    const [filters, setFilters] = useState([
        { id: 1, name: 'Lindsay Walton', notifications: true, active: true, history: 10 },
        { id: 2, name: 'Q Bet - peste 1.5 prima repriza', notifications: false, active: false, history: 12 },
        { id: 3, name: 'At least 1 goal in game', notifications: true, active: true, history: 10 },
    ])

    const toggleFilter = (id: number, field: string, b: boolean) => {
        const newFilters = filters.map((filter) => {
            if (filter.id === id) {
                filter[field] = b
            }
            return filter
        })

        setFilters(newFilters)
    }

    return (
        <div className="table-filters-wrapper">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table className="min-w-full divide-y divide-gray-300">
                    <thead>
                        <tr>
                            <th scope="col"
                                className="py-3.5 pl-6 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                                style={{width: '50%'}}
                            >
                                Name
                            </th>
                            <th scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                <div className="flex-center">
                                    Notifications
                                </div>
                            </th>
                            <th scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                <div className="flex-center">
                                    Active
                                </div>
                            </th>
                            <th scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                <div className="flex-center">
                                    Matches history
                                </div>
                            </th>
                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                                <span className="sr-only">Edit</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="table-body divide-y divide-gray-200">
                    {filters.map((filter) => (
                        <tr key={filter.name}>
                            <td className="whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                {filter.name}
                            </td>
                            <td className="flex-center whitespace-nowrap px-3 py-3 text-sm text-gray-500">
                                <div className="notification-icon-wrapper ">
                                    <div className="notification-icon" onClick={() => toggleFilter(filter.id, 'notifications', !filter.notifications)}>
                                        {filter.notifications ?
                                            <NotificationsIcon className="active"/> :
                                            <NotificationsOffIcon className="inactive"/>
                                        }
                                    </div>
                                </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-3 text-sm text-gray-500">
                                <div className="active-icon-wrapper flex-center">
                                    <div className="active-icon" onClick={() => toggleFilter(filter.id, 'active', !filter.active)}>
                                        {filter.active ?
                                            <ToggleOnIcon className="active"/> :
                                            <ToggleOffIcon className="inactive"/>
                                        }
                                    </div>
                                </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-3 text-sm text-gray-500">
                                <div className="display-flex flex-center">
                                    <div className="history-matches">{filter.history}</div>
                                </div>
                            </td>
                            <td className="flex-center relative whitespace-nowrap py-3 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                     stroke-linejoin="round" className="feather feather-edit edit-button"
                                >
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                </svg>
                                {/*<EditNoteIcon className="edit-button">Edit</EditNoteIcon>*/}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableFilters
